import React from 'react';
import reporter from '../../monitoring/errorReporter';
import CrashScreen from '../CrashScreen';

export default class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			hasError: false,
			errorId: null,
		};
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, info) {
		try {
			const id = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2,8)}`;
			this.setState({ errorId: id });

			reporter.captureError(error, {
				source: 'react-error-boundary',
				componentStack: info && info.componentStack ? info.componentStack : undefined,
				errorId: id,
			});
		} catch (e) {
			// noop
		}
	}

	render() {
		if (this.state.hasError) {
			return <CrashScreen onReload={() => window.location.reload()} errorId={this.state.errorId} />;
		}
		return this.props.children;
	}
}
